import { isWeChat, GlobalEnv, Env } from './env'
import { Api } from './config'
import { Cookie } from './cookie'
import { defaultAppFn } from './app'

abstract class BaseAuth {
    protected isAuth(): boolean {
        if (isWeChat()) {
            return this.isWeChatFollow()
        } else {
            return this.isSmmUser()
        }
    }

    private isSmmUser(): boolean {
        return Cookie.get() !== ''
    }

    private isWeChatFollow(): boolean {
        return Cookie.get() !== '' || Cookie.get(Cookie.WECHATIDKEY) !== ''
    }
}

class AppAuth extends BaseAuth {
    public check() {
        if (!this.isAuth()) {
            defaultAppFn.Apply('app_login')
        }
    }
}

class WebAuth extends BaseAuth {
    public check() {
        if (!this.isAuth()) {
            window.location.href = Api().link_m + "/vote_bind_sign?referer=" + encodeURIComponent(window.location.href) + "&wxchat_state=subscribe"
        }
    }
}

class Wechat extends BaseAuth {
    public check() {
        if (!this.isAuth()) {
            window.location.href = Api().link_m + "/vote_bind_sign?referer=" + encodeURIComponent(window.location.href) + "&wxchat_state=subscribe"
        }
    }
}

class IsAuth extends BaseAuth {
    public check() {
        return this.isAuth()
    }
}

class CheckAuth {
    public static check() {
        switch (GlobalEnv) {
            case Env.App:
                new AppAuth().check()
                break
            case Env.Web:
                new WebAuth().check()
                break
            default:
                new Wechat().check()
        }
    }
}

export {
    CheckAuth,
    IsAuth
}


// WEBPACK FOOTER //
// ./src/utils/auth.ts